exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vh6I{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "vh6I",
	"root": "vh6I"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/accueil/Accueil.css
// module id = 203
// module chunks = 0